import React from 'react';
import BikeCard from 'components/BikeCard';
import { useSelector } from 'react-redux';
import { getBikeModel, getOfferBanner } from 'src/redux/app/selectors';
import FinanceOptionSummary from 'components/FinanceOptionSummary';
import YourDetails from 'components/YourDetails';
import OfferBanner from 'components/OfferBanner';

const StepTwo = () => {
  const bikeModel = useSelector(getBikeModel);
  const offerBanner = useSelector(getOfferBanner);

  return (
    <>
      <BikeCard bikeModel={bikeModel} />
      {offerBanner && <OfferBanner offerBanner={offerBanner} />}
      <FinanceOptionSummary />
      <YourDetails />
    </>
  );
};

export default StepTwo;
